<template>

    <div class="store-reviews" :data-store-id="reviewsData.store.store_id">
        <div class="flex flex-wrap sm:flex-nowrap justify-center items-center mb-4">
            <div class="total-score flex-initial text-center mb-8">
                <div class="stars">
                    <star-rating
                            :size="6"
                            :rating="reviewsData.avg_score"
                            class="mb-1 leading-normal dark:text-slate-200"
                    ></star-rating>
                    <span class="block dark:text-slate-200">
                        {{ reviewsData.num_reviews }} {{ _('Store_reviews.x_reviews') }}
                    </span>
                </div>
            </div>

            <div v-if="loggedIn" class="hidden md:block rating-filter flex-initial text-xs mb-8 md:mr-8 md:pl-8">
                <div v-for="n in [5, 4, 3, 2, 1]" class="block mb-3">
                    <a v-if="reviewsData.scoreOverview[n]" class="text-black cursor-pointer flex items-center" href="#"
                       @click.stop.prevent="reviewsList(n)" :data-rating="n">
                        <span class="inline-block">
                            <star-rating
                                    :size="4"
                                    :rating="n"
                                    cursor="pointer"
                                    class="leading-normal"
                            ></star-rating>
                        </span>
                        <span class="ml-2 w-12 inline-block dark:text-slate-200">({{ reviewsData.score_overview[n] ? reviewsData.score_overview[n] : 0  }})</span>
                        <span class="rating-bar w-32 h-2 inline-block relative bg-gray dark:bg-slate-500 flex">
                            <span class="h-2 inline-block bg-black dark:bg-gray-100" :style="{width: Math.floor((reviewsData.score_overview[n] / reviewsData.num_reviews) * 100) + '%'}">&nbsp;</span>
						</span>
                    </a>
                </div>
            </div>

            <div v-if="loggedIn" class="extra-fields-overview flex-initial text-xs md:pl-8 md:mb-4">
                <span v-for="field in reviewsData.extra_fields_overview" class="flex items-center mb-1">
					<span class="flex-1 mr-3 text-right dark:text-gray-100">{{ field.title }}:</span>
                    <circle-rating
                        :size="3"
                        :rating="field.avg_score"
                    ></circle-rating>
				</span>
            </div>
        </div>

        <div
            class="grid grid-cols-1 gap-8 justify-center text-sm px-8"
            :class="{
                'md:grid-cols-1': reviews && reviews.length === 1,
                'md:grid-cols-3': reviews && reviews.length > 1 && fullWidth,
                'md:grid-cols-2': reviews && reviews.length > 1 && !fullWidth,
            }"
        >

            <div v-for="review in reviews" class="review-item">
                <p class="float-right font-thin dark:text-gray-200">{{ review.created|date('Y-m-d') }}</p>

                <p>
                    <span v-if="review.author == 'Refundermedlem'" class="text-base font-bold dark:text-slate-200">{{ _(review.author) }}</span>
                    <span v-else class="text-base font-bold dark:text-gray-100">{{ review.author }}</span>
                    <span class="font-thin dark:text-gray-200">{{ _('Store_reviews.verified_buyer') }}</span>

                </p>

                <div class="user-rating inline-block my-4">
                    <star-rating
                            :size="4"
                            :rating="review.score"
                            class="mb-1 leading-normal"
                    ></star-rating>
                </div>

                <h4 class="mb-2 dark:text-slate-200">{{ review.title }}</h4>
                <p class="mb-8 font-thin dark:text-gray-100">{{ review.content }}</p>

                <div class="text-xs">
                    <div v-if="review.extra_rating_fields && review.extra_rating_fields.length > 0">
                        <div class="extra-fields-rating bg-gray-100 dark:bg-slate-700 flex flex-wrap rounded-lg p-4 pb-2 mb-4">
                            <div v-for="extra in review.extra_rating_fields" class="w-full md:w-1/2 mb-2">
                                <div class="flex items-center">
                                    <span class="inline-block font-thin flex-1 text-right mr-2 dark:text-slate-200">{{ extra.title }}:</span>
                                    <circle-rating
                                        :size="3"
                                        :rating="extra.content"
                                    ></circle-rating>
                                </div>
                            </div>
                        </div>

                        <div v-for="extra in review.extra_choice_fields" class="flex flex-wrap">
                            <div class="w-full mb-1">
                                <p class="flex">
                                    <span class="font-bold flex-1 text-right mr-2 dark:text-slate-200">{{ extra.title }}: </span>
                                    <span class="font-thin flex-1 text-left dark:text-gray-100">{{ extra.content }}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>

</template>
<style>

</style>
<script>
    import { mapGetters } from 'vuex'
    import axios from 'axios';

    export default {
        filters: {
            date: function (value) {

                return value.substring(0, 10);
                //return value.substring(0, value.length - 9);
            }
        },
        props: {
            reviewsData: {
                required: true
            },

            fullWidth: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            ...mapGetters('general', ['_', 'loggedIn'])
        },
        data() {
            return {
                reviews: {},
                store_id: '',
                rating: null,
                pagination: null,
                page: 1,
                limit: 9,
            }
        },
        mounted: function () {

            this.$nextTick(function () {
                this.reviews = this.reviewsData.reviews.data;
                this.store_id = this.reviewsData.store.store_id;
                this.pagination = this.reviewsData.pagination;
                this.limit = this.fullWidth ? 9 : 8;
            });
        },
        methods: {
            scrollToReviews(theElement) {
                var selectedPosX = 0;
                var selectedPosY = 0;

                while (theElement != null) {
                    selectedPosX += theElement.offsetLeft;
                    selectedPosY += theElement.offsetTop;
                    theElement = theElement.offsetParent;
                }

                window.scrollTo(selectedPosX,selectedPosY);

            },
            reviewsList(rating) {
                this.page = 1;
                this.fetchAndUpdateReviews(rating);
            },
            fetchAndUpdateReviews(rating = null) {
                this.rating = rating;
                axios.get('/store/ajax_data_store_reviews', {
                    params: {store_id: this.store_id, page: this.page, rating: rating, limit: this.limit}
                }).then(({data}) => {
                    if (data) {
                        this.reviews = data.reviews;
                        this.pagination = data.pagination;
                        document.querySelector('.num-reviews-hl').innerHTML = this._('Store_reviews.headline') + ' (' + data.num_filtered_reviews + ')';
                        this.scrollToReviews(document.querySelector('.store-reviews-container'));

                    } else {
                        this.error = data.msg;
                    }
                }).catch(((errors) => {
                    this.error = _('modal.instagram_offer.unknown_error')
                }));
            },
            paginationOnClick(event) {
                event.preventDefault();

                let page = event.target.dataset.ciPaginationPage;
                if (parseInt(page) > 0) {
                    this.page = page;
                    this.fetchAndUpdateReviews(this.rating);
                    this.scrollToReviews(document.querySelector('.store-reviews-container'));
                }

                return;
            }

        }
    }
</script>